import { Button, Checkbox, Divider, TimePicker, Tooltip } from "antd";
import './EditCalendar.css'
import { Dayjs } from "dayjs";
import dayjs from '../../../utils/dayjs'
import React, { useEffect, useState } from "react";
import { CopyOutlined, PlusOutlined } from '@ant-design/icons';
import { Calendar, WeekAvailable } from "../../../models/calendar/Calendar.model";
import { CalendarService } from "../../../services/calendar.api.client";
import { useModalCalendar } from "../../../contexts/calendar/ModalCalendarContext.context";
import { useConfig } from "../../../contexts/ConfigContext";
import { useCompany } from "../../../contexts/CompanyContext";
import { useUpdater } from "../../../contexts/calendar/UpdateCalendarSelect.context";
import Cookies from 'js-cookie';
import { useCalendar } from "../../../contexts/calendar/CalendarContext.context";


type WorkHours = {
  day: string;
  start: Dayjs;
  end: Dayjs;
  enabled: boolean;
};

type Props = {
    calendar:Calendar
}

const ConfigurationCalendar = ({ calendar }: Props) => {
  const { options,setOptions } = useModalCalendar();
  const { setCalendar } = useCalendar();
  const { company } = useCompany();
  const {setUpdater} = useUpdater();
  const { config } = useConfig();
  const [workHours, setWorkHours] = useState<WorkHours[]>([] as WorkHours[]);
  const startTime = dayjs('08:00', 'HH:mm');
  const endTime = dayjs('23:00', 'HH:mm');

  useEffect(() => {
    //console.log('Calendar en ConfigurationWeekHour:',calendar);
    setUpdater(false);
    if (calendar.weekAvailable && calendar.weekAvailable.length > 0) {
      const updatedWorkHours: WorkHours[] = [
        { day: "Lunes", start: dayjs('08:00', 'HH:mm'), end: dayjs('23:00', 'HH:mm'), enabled: false },
        { day: "Martes", start: dayjs('08:00', 'HH:mm'), end: dayjs('23:00', 'HH:mm'), enabled: false },
        { day: "Miércoles", start: dayjs('08:00', 'HH:mm'), end: dayjs('23:00', 'HH:mm'), enabled: false },
        { day: "Jueves", start: dayjs('08:00', 'HH:mm'), end: dayjs('23:00', 'HH:mm'), enabled: false },
        { day: "Viernes", start: dayjs('08:00', 'HH:mm'), end: dayjs('23:00', 'HH:mm'), enabled: false },
        { day: "Sábado", start: dayjs('08:00', 'HH:mm'), end: dayjs('23:00', 'HH:mm'), enabled: false },
        { day: "Domingo", start: dayjs('08:00', 'HH:mm'), end: dayjs('23:00', 'HH:mm'), enabled: false },
      ];
      calendar.weekAvailable.forEach((wa) => {
        const index = wa.numberDay;
        if (index >= 0 && index < updatedWorkHours.length) {
          updatedWorkHours[index] = {
            day: updatedWorkHours[index].day,
            start: dayjs().hour(wa.start.hour).minute(wa.start.minute),
            end: dayjs().hour(wa.end.hour).minute(wa.end.minute),
            enabled: true,
          };
        }
      });
      setWorkHours(updatedWorkHours);
    }
  }, [calendar]);

  /*const startTime = dayjs('08:00', 'HH:mm');
  const endTime = dayjs('23:00', 'HH:mm');
  const [workHours, setWorkHours] = useState<WorkHours[]>([
    { day: "Lunes", start: startTime, end: endTime, enabled: true },
    { day: "Martes", start: startTime, end: endTime, enabled: true },
    { day: "Miércoles", start: startTime, end: endTime, enabled: true },
    { day: "Jueves", start: startTime, end: endTime, enabled: true },
    { day: "Viernes", start: startTime, end: endTime, enabled: true },
    { day: "Sábado", start: startTime, end: endTime, enabled: false },
    { day: "Domingo", start: startTime, end: endTime, enabled: false },
  ]);*/

  const handleWorkHoursChange = (index: number, field: "start" | "end", value: Dayjs) => {
    const updated = [...workHours];
    updated[index][field] = value;
    setWorkHours(updated);
  };

  const handleConfigurationWeekHour = () => {
    /*const updated = [...workHours];
    updated[index][field] = value;
    setWorkHours(updated);*/
    const data = workHours.filter((wh)=>wh.enabled).map((wh)=>{
      const response:WeekAvailable = {
        numberDay: wh.day === "Lunes" ? 0 : wh.day === "Martes" ? 1 : wh.day === "Miércoles" ? 2 : wh.day === "Jueves" ? 3 : wh.day === "Viernes" ? 4 : wh.day === "Sábado" ? 5 : wh.day === "Domingo" ? 6 : -1,
        start: {
          hour: wh.start.hour(),
          minute: wh.start.minute(),
          period: wh.start.hour() >= 12 ? "PM" : "AM"
        },
        end: {
          hour: wh.end.hour(),
          minute: wh.end.minute(),
          period: wh.end.hour() >= 12 ? 'PM' : 'AM'
        }
      }
      return response;
    });
    CalendarService.updateCalendar({ 
      id: calendar.id, 
      uid: options.id, 
      weekAvailable: data 
    }, company.current, config.key)
    .then((response)=>{
      setUpdater((prev)=>!prev);
      const weekrules = [false,false,false,false,false,false,false].map((_,i)=>(data.some((day)=>day.numberDay==i)))
      setCalendar((prev)=>({...prev,availableWeekRules:weekrules,weekAvailable:data}));
      Cookies.set("calendar_id", calendar.id, {
          expires: 1/24, // 1 día
          path: "/", // Disponible en toda la aplicación
      });
      setOptions((prev) => ({
          ...prev,
          isopen: false,
          isEditing: false,
          isConfiguration: false,
      }))
    }).catch((error)=>{
      console.error('Error actualización horas hábiles:',error);
    });



    

  };
  /*const checkIfEnabled = useCallback((index: number) => {
    console.log("checkIfEnabled",index,workHours[index]);
    return workHours[index].enabled;
  },[workHours]);*/
  /*const handleSave = () => {
    console.log("Horas hábiles:", workHours);
    console.log("Usuarios:", users);
    alert("Configuración guardada en consola 🚀");
  };*/

  return (
      <div style={{ marginTop: '16px' }}>
        <div className="flex flex-col gap-2" style={{ marginBottom: '4px' }}>
          {workHours.map((wh, i) => (
              <div key={wh.day} className={`schedule-row ${wh.enabled ? 'active' : ''}`}>
                {/* Column 1: Checkbox + Day Name */}
                <div className="schedule-day-info">
                  <Checkbox checked={wh.enabled}
                    onChange={(e)=>{
                      setWorkHours((prev)=>{
                        const updated = [...prev];
                        updated[i].enabled = e.target.checked;
                        if(e.target.checked){
                          updated[i].start = startTime;
                          updated[i].end = endTime;
                        }
                        return updated;
                      })
                    }}
                  />
                  <span className="schedule-day-label">{wh.day}</span>
                </div>

                {/* Column 2: Content (TimePicker or Status Text) */}
                <div className="schedule-content">
                  {wh.enabled && wh.start && wh.end ? (
                    <TimePicker.RangePicker
                      value={[wh.start, wh.end]}
                      format={'HH:mm'}
                      placement="bottomLeft"
                      onChange={(value) => {
                        if (value) {
                          handleWorkHoursChange(i, "start", value[0]!);
                          handleWorkHoursChange(i, "end", value[1]!);
                        }
                      }}
                      style={{ width: '100%', maxWidth: '200px' }}
                    />
                  ) : (
                    <span className="schedule-status-text">No laborable</span>
                  )}
                </div>

                {/* Column 3: Actions */}
                <div className="schedule-actions">
                  {wh.enabled ? (
                    <Tooltip title="Copiar horario a días activos">
                      <Button
                        icon={<CopyOutlined />}
                        type="text"
                        size="small"
                        onClick={(e) => {
                          e.preventDefault();
                          setWorkHours((prev) => {
                            return prev.map((day) => {
                              if (day.enabled) {
                                return { day: day.day, enabled: true, start: prev[i].start, end: prev[i].end };
                              }
                              return day;
                            });
                          });
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <Button
                      icon={<PlusOutlined />}
                      type="dashed"
                      size="small"
                      onClick={(e) => {
                        e.preventDefault();
                        setWorkHours((prev) => {
                          const updated = [...prev];
                          updated[i].enabled = true;
                          updated[i].start = startTime;
                          updated[i].end = endTime;
                          return updated;
                        });
                      }}
                    >
                      Habilitar
                    </Button>
                  )}
                </div>
              </div>
          ))}
        </div>
        <Divider style={{ margin: '12px 0 12px 0' }} />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', paddingBottom: '8px' }}>
          <Button size="large" type="primary" onClick={handleConfigurationWeekHour}>Guardar Configuración</Button>
        </div>
      </div>);
};

export default ConfigurationCalendar;